// @flow

import React, { type Node } from 'react';

import { type LookAndFeelRootProps } from '@tectonics/look-and-feel';

import { UberV2Page } from './page';
import { UberV2Loading } from './page-loading';
import { UberV2PaymentOpened } from './page-payment-opened';
import { UberV2PaymentPending } from './page-payment-pending';

export default function UberV2Root(props: LookAndFeelRootProps): Node {
  switch (props.stage) {
    case 'loading':
      return (
        <UberV2Page>
          <UberV2Loading {...props} />
        </UberV2Page>
      );

    case 'payment-opened':
      return (
        <UberV2Page>
          <UberV2PaymentOpened {...props} />
        </UberV2Page>
      );

    case 'payment-canceled':
      return null;

    case 'payment-confirmed':
      return null;

    case 'payment-pending':
      return (
        <UberV2Page>
          <UberV2PaymentPending {...props} />
        </UberV2Page>
      );

    default:
      (props.stage: empty);
      throw new Error(`Unknown controller stage "${props.stage}"`);
  }
}
